import { render, staticRenderFns } from "./DeleteTruckModal.vue?vue&type=template&id=a755a73e"
import script from "./DeleteTruckModal.vue?vue&type=script&lang=ts"
export * from "./DeleteTruckModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports